export default __webpack_public_path__ + "static/18-1c4237cb980bf75c3e2074574a2d0139.webp";